import { createContext, useContext } from 'react';

const PropertyTextEditorContext = createContext({});
const PropertyTextEditorContextProvider = PropertyTextEditorContext.Provider;
const usePropertyTextEditorContext = () => useContext(PropertyTextEditorContext);

export { PropertyTextEditorContextProvider, usePropertyTextEditorContext };
